import api from '@/api';
import { API_BASE_URL } from '../..';
import { CustomTermsRequest, CustomTermsResponse } from './CustomTerms.types';

const CONTROLLER_URL = `${API_BASE_URL}/custom-terms`;

export async function createCustomTerms(terms: CustomTermsRequest) {
  const result = (await api.post(CONTROLLER_URL, terms, null)) as unknown;
  return result as CustomTermsResponse;
}

export async function updateCustomTerm(terms: CustomTermsRequest) {
  const result = (await api.put(CONTROLLER_URL, terms, null)) as unknown;

  return result as CustomTermsResponse;
}

export async function readCustomTerm(companyId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/company/${companyId}`,
    null,
  )) as unknown;

  return result as CustomTermsResponse;
}
